import request from '@/utils/request.js';
import { encryptext, decrypinfo, decryptext } from '@/utils/JK.js';
import { Session } from '@/utils/storage.js';
import { MessageBox, Message } from 'element-ui'
import upload from '@/utils/Upload.js';
import common from '@/utils/common.js';


//获取账号角色；
async function getusertype()
{
	return decrypinfo(Session.get("Hasee"));
}



//查询；
async function schSend(type,str)
{
	const url   = 'query_current_warning';
	const info  = await getusertype();
	const val   = {
		AccountID: info.AccountInfo.AccountID,
		Level: parseInt(type),
	};
	
	const AccountType = common.GetUserRole();
	if(AccountType==='超级管理员'||AccountType==='系统管理员') val.OperatorID = str;
	else val.OperatorID = info.AccountInfo.OperatorID;
	
	const token = await upload.GetToken();
	if(!token) return false;
	
    let data   = encryptext(val,url,info);
    let res    = await request({url:url,method:'post',data,realme:token});

    if(res){
    	const resData = await decryptext(res.Data,info);
    	if(resData){
		    if(resData.SuccStat===0) return SchResDat(resData.Infos, info, AccountType);
    	}
    }
    return false;
}


//获取预警信息--返回数据处理；
async function SchResDat(res, info, AccountType)
{
	var arr = [];

	if(AccountType==='充电站'){
		//该用户无充电站ID；
		if(info.AccountInfo.StationID==='') return arr;

		//根据用户绑定的电站ID，获取电站详细数据；
		let StationInfo = await GetStationInfo(info);
		if(StationInfo){
			//充电站账户；
			for(let k in res){
				if(res[k].StationName===StationInfo.StationName){
					arr = res[k];
					break;
				}
			}
		}

	}else arr = res;

	return arr;
}



//根据用户充电站ID获取充电站信息；
async function GetStationInfo(info)
{
	const url   = 'charge_station_info_query';
	const val   = {
		AccountID: info.AccountInfo.AccountID,
		StationID: info.AccountInfo.StationID,
	};

	const token = await upload.GetToken();
	if(!token) return false;
	
    let data   = encryptext(val,url,info);
    let res    = await request({url:url,method:'post',data,realme:token});

    if(res){
    	const resData = await decryptext(res.Data,info);
    	if(resData){
		    if(resData.SuccStat===0) return resData.StationInfos;
    	}
    }
    return false;
}


export default {
	getusertype,
	schSend
}